module.exports = __webpack_public_path__ + "img/card5.62475a7e.png";